import './pickerOverlayLayout.css';

const overlayAlignments = new WeakMap();

function alignmentKey(overlay, control) {
  const bounds = control.getBoundingClientRect();
  const viewport = window.visualViewport;
  return JSON.stringify([
    bounds.left,
    bounds.top,
    bounds.width,
    bounds.height,
    overlay.offsetWidth,
    overlay.offsetHeight,
    window.scrollX,
    window.scrollY,
    window.innerWidth,
    window.innerHeight,
    viewport?.width,
    viewport?.height,
    viewport?.offsetLeft,
    viewport?.offsetTop,
  ]);
}

// PrimeVue realigns after every component update, including keyboard focus.
// Keep an open BayHive picker still until its actual layout changes.
export function alignPickerOverlay(overlay, control, align) {
  sizePickerOverlay(overlay, control);
  const stabilize = overlay && control?.ownerDocument?.documentElement?.dataset.uiBrand === 'bayhive';
  const previous = stabilize ? overlayAlignments.get(overlay) : null;
  if (previous && previous.control === control && previous.key === alignmentKey(overlay, control)) return;

  const result = align();
  sizePickerOverlay(overlay, control);
  if (stabilize) {
    overlayAlignments.set(overlay, { control, key: alignmentKey(overlay, control) });
  }
  return result;
}

// PrimeVue owns placement and keyboard behavior. Its default minimum width
// allows long labels to widen the portal; these shared fields use their
// control's width instead, with normal wrapping inside the real options.
export function sizePickerOverlay(overlay, control) {
  if (!overlay || !control?.getBoundingClientRect || typeof window === 'undefined') return;
  const fieldWidth = control.getBoundingClientRect().width;
  if (!fieldWidth) return;
  const viewportWidth = Math.max(0, (window.visualViewport?.width || window.innerWidth) - 16);
  const width = `${Math.min(fieldWidth, viewportWidth)}px`;
  overlay.classList.add('shop-picker-overlay');
  overlay.style.boxSizing = 'border-box';
  overlay.style.width = width;
  overlay.style.minWidth = width;
  overlay.style.maxWidth = width;
}
